import { UiModalOptions } from "../modal.models";
import { UiModalComponent } from "../modal.component";
import { ModalOptions } from "ng-zorro-antd/modal";

export function applyConfigDefaults(config: UiModalOptions, defaultOptions: UiModalOptions): UiModalOptions {
  return { ...defaultOptions, ...config };
}

export function getValueWithConfig<T>(userValue: T | undefined, configValue: T | undefined, defaultValue: T): T | undefined {
  return typeof userValue === "undefined" ? (typeof configValue === "undefined" ? defaultValue : configValue) : userValue;
}

/**
 * Assign the params into the content component instance.
 *
 * @deprecated Should use dependency injection to get the params for user
 * @breaking-change 13.0.0
 */
export function setContentInstanceParams<T>(instance: T, params: Partial<T> | undefined): void {
  Object.assign(instance, params);
}

export function getConfigFromComponent(component: UiModalComponent): UiModalOptions {
  const transformedOptions: UiModalOptions = {};

  if (component) {
    const keys = Object.keys(component);

    for (const index in keys) {
      transformedOptions[keys[index].replace("nz", "ui")] = component[keys[index]];
    }

    return transformedOptions;
  } else {
    return transformedOptions;
  }
}

export function TransformModalOptions(options: UiModalOptions): ModalOptions {
  const transformedOptions: ModalOptions = {};

  if (options) {
    const keys = Object.keys(options);

    for (const index in keys) {
      transformedOptions[keys[index].replace("ui", "nz")] = options[keys[index]];
    }

    return transformedOptions;
  } else {
    return transformedOptions;
  }
}
